import { render, staticRenderFns } from "./contractsChart.vue?vue&type=template&id=688c63f4&scoped=true"
import script from "./contractsChart.vue?vue&type=script&lang=js"
export * from "./contractsChart.vue?vue&type=script&lang=js"
import style0 from "./contractsChart.vue?vue&type=style&index=0&id=688c63f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c63f4",
  null
  
)

export default component.exports